module.exports = __webpack_public_path__ + "img/add-to-android-wallet-logo2.b9709b94.png";